import React from "react";
import { FaUserTie, FaLinkedinIn, FaEnvelope } from "react-icons/fa";

const LeadershipPage = () => {
  const leaders = [1, 2, 3, 4];

  return (
    <div className="relative bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] min-h-screen overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1298b5]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#f97316]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12 animate-fadeInDown">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#1298b5] to-[#0b819b] rounded-2xl text-white mb-5 shadow-lg">
            <FaUserTie className="text-3xl" />
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-[#073b4c] mb-3">
            Leadership <span className="text-[#1298b5]">Team</span>
          </h1>

          <div className="w-24 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full mb-5"></div>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The leaders driving our mission forward – dedicated, passionate,
            and experienced.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 animate-fadeInUp">
          {leaders.map((i) => (
            <div
              key={i}
              className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-[#d8f4f8] hover:border-[#1298b5]/50"
            >
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="w-24 h-24 bg-[#eafaff] rounded-full flex items-center justify-center text-4xl text-[#1298b5] border-4 border-white shadow-lg group-hover:bg-[#1298b5] group-hover:text-white transition-all duration-300">
                  👤
                </div>

                <div className="text-center md:text-left flex-1">
                  <h3 className="text-xl font-bold text-[#073b4c]">
                    Leader {i}
                  </h3>

                  <p className="text-[#1298b5] font-semibold text-sm mb-3">
                    Position
                  </p>

                  <p className="text-gray-600 text-sm leading-relaxed">
                    Brief description of the leader's role and background.
                  </p>

                  <div className="flex gap-3 mt-4 justify-center md:justify-start">
                    <a
                      href="#"
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#1298b5] hover:text-white transition"
                    >
                      <FaLinkedinIn />
                    </a>

                    <a
                      href="#"
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#f97316] hover:text-white transition"
                    >
                      <FaEnvelope />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-5">
            Our leadership team is always open to dialogue and collaboration.
          </p>

          <button className="bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white px-8 py-3 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300">
            Contact Leadership
          </button>
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.08); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
          100% { transform: translate(0px, 0px) scale(1); }
        }

        .animate-blob {
          animation: blob 7s infinite;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default LeadershipPage;